import { getAuthHeader } from "src/utils/superagent";
import request from "superagent";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
const createNewUser = async (data) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .post(`${global.api}/facilityUser`)
      .set(await getAuthHeader())
      .send(data)
      .then(({ body }) => body)
  );
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
const updateUserInfo = async (data) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .put(`${global.api}/facilityUser`)
      .set(await getAuthHeader())
      .send(data)
      .then(({ body }) => body)
  );
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
const removeUser = async (data) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .delete(`${global.api}/facilityUser`)
      .set(await getAuthHeader())
      .send(data)
      .then(({ body }) => body)
  );
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
const activateUser = async (data) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .post(`${global.api}/facilityUser/activate`)
      .set(await getAuthHeader())
      .send(data)
      .then(({ body }) => body)
  );
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'query' implicitly has an 'any' type.
const fetchUserCount = async (query) => {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityUser/count`)
    .set(await getAuthHeader())
    .query(query);
  return body.count;
};

/**
 *
 * @param {any} query
 * @returns {Promise<IUser[]>}
 */
// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'query' implicitly has an 'any' type.
const fetchUsers = async (query) => {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityUser/list`)
    .set(await getAuthHeader())
    .query(query);
  return body;
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'id' implicitly has an 'any' type.
const findUserById = async (id) => {
  const { body } = await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facilityUser/${id}`)
    .set(await getAuthHeader())
    .send();
  return body;
};

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'facilityId' implicitly has an 'any' type.
const findUserWithEmail = async ({ facilityId, email }) => {
  try {
    const { body } = await request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .get(`${global.api}/facilityUser/findByEmailAddUser`)
      .set(await getAuthHeader())
      .query({ facilityId, email });
    return body.user;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error("Couldn't find user", err);
    return null;
  }
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
const linkNewUser = async (data) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .put(`${global.api}/facilityUser/linkNewUser`)
      .set(await getAuthHeader())
      .send(data)
      .then(({ body }) => body)
  );
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'data' implicitly has an 'any' type.
const unLinkUser = async (data) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .put(`${global.api}/facilityUser/unLinkUser`)
      .set(await getAuthHeader())
      .send(data)
      .then(({ body }) => body)
  );
};

export {
  createNewUser,
  updateUserInfo,
  fetchUserCount,
  fetchUsers,
  removeUser,
  activateUser,
  findUserWithEmail,
  findUserById,
  linkNewUser,
  unLinkUser,
};
